module.exports = __webpack_public_path__ + "img/loading.3c44fafb.gif";